import React from "react";
import { Button, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AuthPageLayout from "../../../components/layout/AuthPageLayout";
import { images } from "../../../assets";
import { ROUTES } from "../../../constants";
import {
  SuccessContainer,
  SuccessIcon,
  SuccessTitle,
  SuccessSubtitle,
  SuccessActions,
} from "./SuccessPage.styled";

const SuccessPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGoToDashboard = () => {
    navigate(ROUTES.LOGIN);
  };

  return (
    <AuthPageLayout>
      <SuccessContainer>
        <SuccessIcon>
          <Box
            component="img"
            src={images.diamond}
            alt="Success icon"
            sx={{ width: "120px", height: "120px" }}
          />
        </SuccessIcon>

        <SuccessTitle>{t("success.title")}</SuccessTitle>

        <SuccessSubtitle>{t("success.subtitle")}</SuccessSubtitle>

        <SuccessActions>
          <Button
            variant="contained"
            onClick={handleGoToDashboard}
            sx={{ minWidth: 200 }}
          >
            {t("createPassword.goToLogin")}
          </Button>
        </SuccessActions>
      </SuccessContainer>
    </AuthPageLayout>
  );
};

export default SuccessPage;
